import {
  Badge,
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
} from '@mantine/core';
import {
  IconBook2,
  IconShieldCheck,
  IconUsers,
  type TablerIcon,
} from '@tabler/icons-react';
import { useAuth } from '@/auth/auth-context';
import { PageHeader } from '@/components/page-header';

/**
 * Screens the API cannot serve yet.
 *
 * Shown as explicitly pending rather than as zeroes: a "0 users" tile would
 * be indistinguishable from a real, empty database.
 */
const pending: { title: string; icon: TablerIcon; detail: string }[] = [
  {
    title: 'Users',
    icon: IconUsers,
    detail:
      'The model exists and first runs are recorded, but there is no screen for browsing individual users yet.',
  },
  {
    title: 'Content',
    icon: IconBook2,
    detail: 'The AI pipeline and its content model are still undecided.',
  },
];

export function DashboardPage() {
  const { user } = useAuth();

  return (
    <Stack gap="lg">
      <PageHeader
        title="Dashboard"
        description="An overview of the platform will live here."
      />

      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        <Card>
          <Stack gap="xs">
            <Group justify="space-between" wrap="nowrap">
              <Group gap="xs" wrap="nowrap">
                <ThemeIcon variant="light" color="brand" radius="md">
                  <IconShieldCheck size={18} />
                </ThemeIcon>
                <Text fw={600}>Signed in as</Text>
              </Group>
              {user && (
                <Badge variant="light" color="brand">
                  {user.role}
                </Badge>
              )}
            </Group>
            <Stack gap={2}>
              <Text size="sm">{user?.displayName ?? '—'}</Text>
              <Text size="sm" c="dimmed">
                {user?.email}
              </Text>
            </Stack>
          </Stack>
        </Card>

        {pending.map((item) => (
          <Card key={item.title}>
            <Stack gap="xs">
              <Group justify="space-between" wrap="nowrap">
                <Group gap="xs" wrap="nowrap">
                  <ThemeIcon variant="light" color="gray" radius="md">
                    <item.icon size={18} />
                  </ThemeIcon>
                  <Text fw={600}>{item.title}</Text>
                </Group>
                <Badge variant="light" color="gray">
                  Not built
                </Badge>
              </Group>
              <Text size="sm" c="dimmed">
                {item.detail}
              </Text>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
